import {
  ClientWorkFlowStatus,
  InvoiceStatus,
  IPayableSchema
} from "@wingspanhq/payments/dist/interfaces";
import React from "react";

import {
  WSActions,
  WSElement,
  WSPillTheme,
  WSSectionToolbar,
  WSTable,
  WSTableCell
} from "@wingspanhq/fe-component-library";
import { IconType } from "@wingspanhq/fe-component-library/dist/lib/components/common/WSPill/types";
import queryString from "qs";
import { useHistory } from "react-router-dom";
import { usePayablesQuery } from "../../../Invoices/components/NewPayablesTable/PayablesTable";
import { WSQueries } from "../../../query/WSQuery";

type RecentPayablesWidgetProps = {
  payeeId: string;
};

export const RecentPayablesWidget: React.FC<RecentPayablesWidgetProps> = ({
  payeeId
}) => {
  const history = useHistory();

  const queryPayables = usePayablesQuery(
    {
      payeeId
    },
    {
      size: 5
    }
  );

  return (
    <WSQueries queries={{ queryPayables }}>
      {({ queryPayablesData }) => {
        if (queryPayablesData.data.length === 0) {
          return null;
        }

        return (
          <WSElement>
            <WSSectionToolbar title="Recent payables" mb="S" />

            <WSTable<IPayableSchema>
              tableData={queryPayablesData.data.map(payable => ({
                id: payable.payableId,
                data: payable
              }))}
              onRowClick={row => {
                history.push(`/member/invoices/payables/all/${row.id}`);
              }}
              columns={[
                {
                  config: {
                    header: {
                      text: "Invoice #"
                    },
                    gridTemplateSizeMax: "2fr"
                  },
                  renderFunction: ({ data }) => {
                    // const engagement = engagements.find(
                    //   e => e.payerPayeeEngagementId === data.collaboratorId
                    // );

                    return (
                      <WSTableCell
                        text={`#${data.invoiceNumber ?? "Pending"}`}
                        // secondaryText={
                        //   engagement
                        //     ? getTmpEngagementName(engagement)
                        //     : undefined
                        // }
                      />
                    );
                  }
                },
                {
                  config: {
                    header: {
                      text: "Status"
                    }
                  },
                  renderFunction: ({ data }) => {
                    let icon: IconType<any> = "time";
                    let theme: WSPillTheme = "neutral";
                    let badge: boolean = false;

                    if (
                      data.client.workflowStatus ===
                        ClientWorkFlowStatus.Approved &&
                      (data.status === InvoiceStatus.Open ||
                        data.status === InvoiceStatus.Overdue)
                    ) {
                      icon = "calendar";
                    } else if (data.status === InvoiceStatus.Pending) {
                      icon = "alert";
                      theme = "warning";
                      badge = true;
                    } else if (data.status === InvoiceStatus.Overdue) {
                      icon = "alert";
                      theme = "error";
                      badge = true;
                    } else if (data.status === InvoiceStatus.Paid) {
                      icon = true;
                      theme = "success";
                    } else if (data.status === InvoiceStatus.PaymentInTransit) {
                      icon = "check";
                    } else {
                      icon = "edit";
                    }

                    return (
                      <WSTableCell
                        pill={
                          badge
                            ? {
                                badge,
                                theme,
                                icon
                              }
                            : {
                                theme,
                                icon
                              }
                        }
                      />
                    );
                  }
                }
              ]}
            />
            <WSActions
              alignment="left"
              size="M"
              mt="M"
              buttons={[
                {
                  label: "View all",
                  kind: "Link",
                  onClick: () => {
                    const query = queryString.stringify({
                      payeeId
                    });
                    history.push(`/member/invoices/payables/all?${query}`);
                  }
                }
              ]}
            />
          </WSElement>
        );
      }}
    </WSQueries>
  );
};
